import { render, staticRenderFns } from "./salesChannels.vue?vue&type=template&id=4ccaf02a&scoped=true&"
import script from "./salesChannels.vue?vue&type=script&lang=ts&"
export * from "./salesChannels.vue?vue&type=script&lang=ts&"
import style1 from "./salesChannels.vue?vue&type=style&index=1&id=4ccaf02a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccaf02a",
  null
  
)

export default component.exports